<template>
  <div id="viewProject" v-if="tableData">
    <div class="box">
      <template>
        <el-table :data="tableData" style="width: 100%" border>
          <el-table-column>
            <template
              slot-scope="scope"
            >{{scope.row.create_time.length>3?dayjs.unix(scope.row.create_time).format("YYYY-MM-DD"):scope.row.create_time}}</template>
          </el-table-column>
          <el-table-column label="总金额" width="120">
            <template slot-scope="scope">&yen; {{scope.row.project_money}}</template>
          </el-table-column>
          <el-table-column label="试剂">
            <template slot-scope="scope">&yen; {{scope.row.reagent}}</template>
          </el-table-column>
          <el-table-column label="抗体">
            <template slot-scope="scope">&yen; {{scope.row.antibody}}</template>
          </el-table-column>
          <el-table-column label="耗材">
            <template slot-scope="scope">&yen; {{scope.row.consume}}</template>
          </el-table-column>
          <el-table-column label="设备">
            <template slot-scope="scope">&yen; {{scope.row.facility}}</template>
          </el-table-column>
          <el-table-column label="技术服务">
            <template slot-scope="scope">&yen; {{scope.row.technical_service}}</template>
          </el-table-column>
          <el-table-column label="其他">
            <template slot-scope="scope">&yen; {{scope.row.others}}</template>
          </el-table-column>
        </el-table>
      </template>
      <div>
        <el-button type="text" class="lv0Text" @click="addDialog=true">
          <i class="fas fa-plus"></i>添加更多行
        </el-button>
      </div>
    </div>
    <el-dialog title="提示" :visible.sync="addDialog" width="935px" @closed="handleClose">
      <span>
        <template>
          <el-table :data="[[]]" style="width: 100%" border>
            <el-table-column width="100">
              <template>{{dayjs().format("YYYY-MM-DD")}}</template>
            </el-table-column>
            <el-table-column label="总金额">
              <template>
                <el-input v-model="total" disabled size="mini"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="试剂">
              <template>
                <el-input v-model="form.reagent" placeholder="请输入金额" size="mini"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="抗体">
              <template>
                <el-input v-model="form.antibody" placeholder="请输入金额" size="mini"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="耗材">
              <template>
                <el-input v-model="form.consume" placeholder="请输入金额" size="mini"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="设备">
              <template>
                <el-input v-model="form.facility" placeholder="请输入金额" size="mini"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="技术服务">
              <template>
                <el-input v-model="form.technical_service" placeholder="请输入金额" size="mini"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="其他">
              <template>
                <el-input v-model="form.others" placeholder="请输入金额" size="mini"></el-input>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addDialog = false">取 消</el-button>
        <el-button type="primary" @click="add" :loading="loading">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      serve: this.$store.state.serve,
      //
      mobile: this.$cookies.get("user"),
      token: this.$cookies.get("token"),
      id: this.$route.query.id,
      tableData: null,
      addDialog: false,
      form: {},
      loading: false
    };
  },
  watch: {},
  created() {
    //
    this.$store.state.user_location = "我的项目";
    this.$store.state.user_location2 = "查看项目";
    this.$store.state.leftMenuIndex = 9;
    this.initData();
  },
  computed: {
    total: function() {
      var value = 0;
      value = _.add(value, _.toInteger(this.form.reagent));
      value = _.add(value, _.toInteger(this.form.antibody));
      value = _.add(value, _.toInteger(this.form.consume));
      value = _.add(value, _.toInteger(this.form.facility));
      value = _.add(value, _.toInteger(this.form.technical_service));
      value = _.add(value, _.toInteger(this.form.others));
      return value;
    }
  },
  methods: {
    add() {
      this.loading = true;
      this.form.mobile = this.mobile;
      this.form.token = this.token;
      this.form.id = this.id;
      this.axios
        .get(this.serve + "/personal/use_money", {
          params: this.form
        })
        .then(res => {
          this.loading = false;
          if (res.data.msg == "余额不足不能如此改变") {
            this.$message.error("添加失败，预算余额不足");
          } else if ((res.data.status = "success")) {
            this.$message({
              message: "添加完成",
              type: "success"
            });
            this.initData();
            this.addDialog = false;
          }
        });
    },
    handleClose() {
      this.form = {};
    },
    initData() {
      this.axios
        .get(this.serve + "/personal/my_project_detail", {
          params: {
            mobile: this.mobile,
            token: this.token,
            id: this.id
          }
        })
        .then(res => {
          if ((res.data.status = "success")) {
            this.tableData = res.data.data.detail;
            var data = res.data.data;
            this.tableData.unshift({
              antibody: data.antibody,
              consume: data.consume,
              create_time: "总金额",
              facility: data.facility,
              others: data.others,
              reagent: data.reagent,
              technical_service: data.technical_service,
              project_money: data.project_money
            });
            var temp = null;
            for (var item of res.data.data.detail) {
              if (!temp) {
                temp = item;
              } else {
                temp = {
                  antibody: temp.antibody - item.antibody,
                  consume: temp.consume - item.consume,
                  create_time: "余额",
                  facility: temp.facility - item.facility,
                  others: temp.others - item.others,
                  reagent: temp.reagent - item.reagent,
                  technical_service:
                    temp.technical_service - item.technical_service,
                  project_money: temp.project_money - item.project_money
                };
              }
            }
            this.tableData.push(temp);
          }
        });
    }
  }
};
</script>
<style lang="scss">
#viewProject {
  .box {
    background-color: #fff;
    padding: 30px;
    .fa-plus {
      margin-right: 5px;
    }
  }
}
</style>